import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

export interface LoggedinUserSupportPayload {
    email: string
    phone: string
    event: string
    description: string
    sagaCB?: {
        onSuccess: any
        onError: any
    }
}

export interface IState {
    success: boolean
    status: string
    result: any
    errors: any
}

const initialState: IState = {
    success: true,
    result: {},
    errors: null,
    status: STATUS.IDLE
}

const loggedinUserSupport = createSlice({
    name: 'companies/support/ticket',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<LoggedinUserSupportPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.result = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const loggedinUserSupportActions = loggedinUserSupport.actions
export default loggedinUserSupport.reducer
